
import { useState, useEffect } from "react";
import { fetchUniversities, fetchLabsByUniversity, University, Lab } from "@/services/universityService";

export function useUniversityLabData(initialUniversityId: string | null | undefined) {
  const [universities, setUniversities] = useState<University[]>([]);
  const [labs, setLabs] = useState<Lab[]>([]);
  const [selectedUniversity, setSelectedUniversity] = useState<string | null>(initialUniversityId || null);
  
  // Load universities on mount
  useEffect(() => {
    const loadUniversities = async () => {
      const data = await fetchUniversities();
      setUniversities(data);
    };
    
    loadUniversities();
  }, []);
  
  // Load labs when university changes
  useEffect(() => {
    const loadLabs = async () => {
      if (!selectedUniversity) {
        setLabs([]);
        return;
      }
      
      const data = await fetchLabsByUniversity(selectedUniversity);
      setLabs(data);
    };
    
    if (selectedUniversity) {
      loadLabs();
    }
  }, [selectedUniversity]);
  
  // Update universities
  const updateUniversities = (newUniversity: University) => {
    setUniversities([...universities, newUniversity]);
  };
  
  // Update labs
  const updateLabs = (newLab: Lab) => {
    setLabs([...labs, newLab]);
  };
  
  return {
    universities,
    labs,
    selectedUniversity,
    setSelectedUniversity,
    updateUniversities,
    updateLabs
  };
}
